if (!customElements.get('anni25-gwp-banner')) {
  class Anni25GwpBanner extends HTMLElement {
    connectedCallback() {
      this._onClick = (event) => {
        const notifyBtn = event.target.closest('[data-gwp-notify]');
        if (notifyBtn && this.contains(notifyBtn)) {
          this._openModal(document.getElementById(notifyBtn.getAttribute('data-modal-id')));
          return;
        }

        const closeEl = event.target.closest('[data-gwp-notify-close]');
        if (closeEl && this.contains(closeEl)) {
          this._closeModal(closeEl.closest('.gwp-notify-modal'));
        }
      };

      this._onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        this.querySelectorAll('.gwp-notify-modal:not([hidden])').forEach((modal) => this._closeModal(modal));
      };

      this.addEventListener('click', this._onClick);
      document.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      document.removeEventListener('keydown', this._onKeydown);
    }

    _openModal(modal) {
      if (!modal) return;
      modal.hidden = false;
      document.body.classList.add('gwp-notify-open');
    }

    _closeModal(modal) {
      if (!modal) return;
      modal.hidden = true;
      if (!document.querySelector('.gwp-notify-modal:not([hidden])')) {
        document.body.classList.remove('gwp-notify-open');
      }
    }
  }

  customElements.define('anni25-gwp-banner', Anni25GwpBanner);
}
